import { styled } from '@mui/system';
import { Snackbar } from '@mui/material';

const typeStyle = (type) => {
    switch (type) {
        case 'success':
            return {
                '.MuiSnackbarContent-root': {
                    borderBottom: 'solid 6px #2E7D32',
                    backgroundColor: 'var(--ahg-waterloo-darken1)'
                }
            };
        case 'warning':
            return {
                '.MuiSnackbarContent-root': {
                    borderBottom: 'solid 6px #ED6C02',
                    backgroundColor: 'var(--ahg-waterloo-darken1)'
                }
            };
        case 'info':
            return {
                '.MuiSnackbarContent-root': {
                    borderBottom: 'solid 6px #0288D1',
                    backgroundColor: 'var(--ahg-waterloo-darken1)'
                }
            };
        case 'error':
        default:
            return {
                '.MuiSnackbarContent-root': {
                    borderBottom: 'solid 6px #DD1818',
                    backgroundColor: 'var(--ahg-waterloo-darken1)'
                }
            };
    }
};

export const SnackbarStyled = styled(Snackbar, { shouldForwardProp: (prop) => prop !== 'type' })(({ type = 'error' }) => ({
    fontFamily: 'Open Sans',
    color: 'var(--ahg-secondary-lighten5)',
    maxWidth: '440px' , 
    display: 'flex',  
    flexDirection: 'row',  
    justifyContent: 'space-between', 
    alignItems: 'center', 
    '.MuiSnackbarContent-root': {
        borderBottom: 'solid 6px #DD1818' , 
        backgroundColor: 'var(--ahg-waterloo-darken1)', 
    },
    '.MuiSnackbarContent-message': {
        fontSize: '14px', 
        fontWeight: '600',
        paddingRight: '30px'
    },
    '.MuiSnackbarContent-action': {
        position: 'absolute',
        top: 0,
        right: 0,
        margin: 0,
    },
    ...typeStyle(type)
}));
